<template>
  <section class="booking-module" :class="{ 'popup-version' : isBookingPage }">
    <span class="background" @click="closePopup()"></span>

    <div class="booking-wrap">

        <div class="title-area">
          <!-- <h3 class="h2 mobile" @click="toggleForm()">
            <span>QUOTE/BOOK</span> ONLINE
          </h3> -->
          <h3 class="h2 desktop">{{ isBookingPage ? 'Edit Booking' : 'Instant Quote & Book Online' }}</h3>

          <button v-if="isBookingPage" @click="closePopup()" class="popup-toggle">
            <span class="material-icons">close</span>
          </button>
          <!-- <button @click="toggleForm()" class="mob-toggle">
            +
          </button> -->
        </div>

        <!-- <div class="title-area" v-else>
          <h3 class="h2">Edit Booking</h3>

        </div> -->

        <div
          class="form"
          :class="{ 'open' : true }"
        >

            <div class="form-fields-stack location">
              <div class="form-field sel">
                <form-select-search
                  :locations="locations"
                  :init_id="payload.pickuplocationid"
                  :title="'Pick Up From:'"
                  ref="fromLocationRef"
                  v-on:selectedLocation="selectedLocation"
                ></form-select-search>
              </div>

              <div class="form-field date">
                <Datepicker
                  v-model="payload.pickupdate"
                  format="dd/MM/yyyy"
                  name="pickup"
                  :disabled-dates="disabledDates"
                  @selected="changeUntilsDisabledDates"
                  calendar-class="custom-icon"
                ></Datepicker>
                <img src="/images/calendar.png" class="logo" alt="Calendar Icon" />
                <!-- <span class="logo" @click="openDatePicker(false)"></span> -->
              </div>

              <div class="form-field time">
                <TimeDropdown id="pickup_time" :time="payload.pickuptime" @time="(e) => payload.pickuptime = e" />
              </div>
            </div>

            <div class="form-fields-stack until">
              <div class="form-field sel">
                <form-select-search
                  :locations="locations"
                  :init_id="payload.dropofflocationid"
                  :title="'Drop Off To:'"
                  :isDropoff="true"
                  ref="toLocationRef"
                  v-on:selectedLocation="selectedLocationDropoff"
                ></form-select-search>
              </div>

              <div class="form-field date">
                <Datepicker
                  v-model="payload.dropoffdate"
                  format="dd/MM/yyyy"
                  name="dropoff"
                  :disabled-dates="disabledDatesUntil"
                ></Datepicker>
                <img src="/images/calendar.png" class="logo" alt="Calendar Icon" />
                <!-- <span class="logo" @click="openDatePicker(false)"></span> -->
              </div>

              <div class="form-field time">
                <!-- <label for="dropoff_time">&nbsp;</label> -->
                <TimeDropdown id="dropoff_time" :time="payload.dropofftime" @time="(e) => payload.dropofftime = e" />
              </div>
            </div>

            <div class="form-fields-stack age" :class="{ 'no-promo': noPromo }">
              <div class="form-field sel renter">
                <label for="age" class="renter-label">Renter Age</label>
                <AgeDropdown id="age" :age="payload.ageid" @new-age="getAge" />
              </div>
            </div>

            <div class="form-fields-stack promo" :class="{ 'no-promo': noPromo }">
              <div class="form-field">
                <label for="promo" class="promo-label">Promo Code</label>
                <input type="text" placeholder="Enter Code" v-model="payload.campaigncode">
              </div>
            </div>

            <div class="form-fields-stack save" :class="{ 'no-promo': noPromo }">
              <div class="form-field save">
                <button
                  class="button large red"
                  @click="saveAndSearch()"
                >
                  <img src="/images/search.png" alt="Search Icon" />
                  <!-- <span class="material-symbols-outlined">search</span> -->
                  Find My Car
                </button>
              </div>
            </div>

        </div>

        <!-- <div
          v-if="payload.return"
          class="form-fields-stack location dropoff"
        >
            <div class="form-field">
              <form-select-search
                :locations="locations"
                :init_id="payload.dropofflocationid"
                :title="'Drop off Location'"
                v-on:selectedLocation="selectedLocationDropoff"
              ></form-select-search>
            </div>
        </div> -->

        <div
          class="form-field save-in-popup"
        >
          <button
            class="button large red"
            @click="saveAndSearch()"
          >
            Search for vehicles
          </button>
        </div>

    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker'
import TimeDropdown from "../components/TimeDropdown.vue";
import AgeDropdown from "../components/AgeDropdown.vue";
import * as dayjs from 'dayjs'
const axios = require('axios')
import utc from "dayjs/plugin/utc"
import timezone from "dayjs/plugin/timezone"

export default {
  components: {
    Datepicker,
    TimeDropdown,
    AgeDropdown,
  },

  props: {
    locations: Array,
    age: Array,
    types: Array,
    onewayhire: Array,
    enablepromofield: String,
  },

  data: () => ({
    isOpen: true,
    isBookingPage: false,
    selected: null,
    payload: {
      method: "step2",
      pickuplocationid: 0,
      pickupdate: '',
      pickuptime: '0900',
      dropofflocationid: 0,
      dropoffdate: '',
      dropofftime: '0900',
      ageid: 9,
      vehiclecategorytypeid: "0",
      return: false,
      campaigncode: ''
    },
    pickupStartTime: null,
    pickupEndTime: null,
    dropoffStartTime: null,
    dropoffEndTime: null,
    standDownDay: null,
    disabledDates: {
      to: new Date()
    },
    disabledDatesUntil: {
      to: new Date()
    },
    fromLocationOpen: false,
    fromDateRef: null,
    fromTimeRef: null,
    toLocationOpen: false,
    toDateRef: null,
    toTimeRef: null,

    noPromo: false,
  }),

  mounted () {
    // set cutoff date to yesterday to allow on the day booking
    let currentDate = new Date()
    currentDate.setDate(currentDate.getDate() - 1)
    this.disabledDates.to = currentDate
    this.noPromo = this.enablepromofield === 'false' ? true : false

    this.pickupStartTime = this.setDateTime('09:00')
    this.pickupEndTime = this.setDateTime('16:00')
    this.isMobileWidth()
    this.updatePayload()
    if (this.payload.pickuplocationid) {
      this.selectedLocation(this.payload.pickuplocationid)
    }

    if (this.payload.dropofflocationid) {
      this.selectedLocationDropoff(this.payload.dropofflocationid)
    }

    if (window.location.pathname.startsWith('/booking')) {
      this.isBookingPage = true
      // make sure popup starts closed
      // this.closePopup()
    }
  },

  methods: {
    getAge (e) {
      this.payload.ageid = e
    },

    openDatePicker (isFrom = true) {
      if (!isFrom) {
        this.$refs.toLocationRef.showCalendar();
      } else {
        this.$refs.fromLocationRef.showCalendar();
      }
    },

    saveAndSearch () {
      // search Gisborne
      if (this.payload.pickuplocationid === 20) {
        return this.searchGisborne()
      }

      if (!this.payload.return) {
        this.payload.dropofflocationid = this.payload.pickuplocationid
      }

      let pickuptime = this.getTime(this.payload.pickuptime)
      let dropofftime = this.getTime(this.payload.dropofftime)
      let openAtAllTime = this.getTime('00:00')

      let pickupday = dayjs(this.payload.pickupdate).day()

      let pickuptimeDayjs = this.setDateTime(this.payload.pickuptime)
      let pickupdatetime = dayjs(this.payload.pickupdate).hour(pickuptimeDayjs.hour()).minute(pickuptimeDayjs.minute())
      let standDownDay = dayjs().add(this.noticerequired_numberofdays ? this.noticerequired_numberofdays : 1, 'day')
      let onewayhire = null
      onewayhire = this.onewayhire.filter((item) => {
        return item.location_id === this.payload.pickuplocationid && item.dropoff === this.payload.dropofflocationid
      })

      let openingtime = this.getTime(this.selected.officeschedule[pickupday].openingtime)
      let closingtime = this.getTime(this.selected.officeschedule[pickupday].closingtime)

      console.log('pickupday', pickupday,'pickuptime', pickuptime, 'openingtime', openingtime, 'closingtime', closingtime, this.selected.officeschedule)

      if (!this.payload.pickuplocationid || !this.payload.pickupdate || !this.payload.dropoffdate) {
          this.$store.commit('setPopup', {
            open: true,
            content: '<h6>Error Message</h6><p>Please fill out all required fields to continue.</p>'
          })
      }
      // else if ((pickuptime < openingtime || pickuptime > closingtime) ) {
      //   if (openingtime === '00:00' && closingtime === '00:00') {
      //     this.$store.commit('setPopup', {
      //       open: true,
      //       content: '<h6>Error Message</h6><p>Please update your booking day. Branch is not available on this day </p>'
      //     })
      //   } else {
      //      this.$store.commit('setPopup', {
      //       open: true,
      //       content: '<h6>Error Message</h6><p>Please update your booking time. Pick up times from this location are from ' + openingtime +' - '+ closingtime +' </p>'
      //     })

      //   }

      //   }
        else if (onewayhire.length > 0 && !onewayhire[0].available) {
        let pickupLocation = this.locations.filter((item) => {return item.id === this.payload.pickuplocationid})
        let dropoffLocation = this.locations.filter((item) => {return item.id === this.payload.dropofflocationid})
        this.$store.commit('setPopup', {
            open: true,
            content: '<h6>Error Message</h6><p>We are sorry that your One Way Hire Request from ' + pickupLocation[0].title + ' to ' +  dropoffLocation[0].title +' is currently unavailable online. Please contact the pickup branch direct to check for updated availability.</p>'
          })
      } else if (this.standDownDay !== 0 && pickupdatetime < standDownDay) {
          this.$store.commit('setPopup', {
            open: true,
            content: '<h6>Error Message</h6><p>Sorry but we are unable to process on-line booking requests that are within 24hrs of vehicle collection. Please contact your RaD Branch directly on 0800 73 68 23 to process your booking request at this time.</p>'
          })
      }
      // Check if branch is open on Sunday
      else if (pickupday === 0 && this.selected.officeschedule.length > 0) {
        let sundayStartPickup = this.getTime(this.selected.officeschedule[0].startpickup)
        let sundayEndPickup = this.getTime(this.selected.officeschedule[0].endpickup)
        let sundayStartDropoff = this.getTime(this.selected.officeschedule[0].startdropoff)
        let sundayEndDropoff = this.getTime(this.selected.officeschedule[0].enddropoff)

        if ((pickuptime < sundayStartPickup || pickuptime > sundayEndPickup) && (dropofftime < sundayStartDropoff || dropofftime > sundayEndDropoff)) {
          this.$store.commit('setPopup', {
            open: true,
            content: '<h6>Error Message</h6><p>Please update your booking day. Branch is not available on this day </p>'
          })
        } else {
          this.$store.commit('setBooking', this.payload)
          location.href = '/booking'
          this.closePopup()
        }
      } else if (this.selected.afterhourbookingaccepted) {
        this.$store.commit('setBooking', this.payload)
          location.href = '/booking'
          this.closePopup()

      } else if (pickuptime < this.pickupStartTime || pickuptime > this.pickupEndTime) {
        if (this.pickupStartTime === openAtAllTime && this.pickupEndTime === openAtAllTime) {
            this.$store.commit('setBooking', this.payload)
            location.href = '/booking'
        } else {
          this.$store.commit('setPopup', {
            open: true,
            content: '<h6>Error Message</h6><p>Please update your booking time. Pick up times from this location are from ' + this.pickupStartTime +' - '+ this.pickupEndTime +' </p>'
          })

        }
      } else if (dropofftime < this.dropoffStartTime || dropofftime > this.dropoffEndTime )  {

        if (this.dropoffStartTime === openAtAllTime && this.dropoffEndTime === openAtAllTime) {
            this.$store.commit('setBooking', this.payload)
            location.href = '/booking'
        } else {
          this.$store.commit('setPopup', {
            open: true,
            content: '<h6>Error Message</h6><p>Please update your booking time. Dropoff times from this location are from ' + this.dropoffStartTime +' - '+ this.dropoffEndTime +' </p>'
          })
        }
      } else {

        this.$store.commit('setBooking', this.payload)
        location.href = '/booking'
      }
    },

    searchGisborne () {
      var customParseFormat = require('dayjs/plugin/customParseFormat')
      dayjs.extend(customParseFormat)

      let pickupdate = dayjs(this.payload.pickupdate).format('dddd, D MMMM YYYY,')
      let dropoffdate = dayjs(this.payload.dropoffdate).format('dddd, D MMMM YYYY,')
      let pickuptime = dayjs(this.payload.pickuptime, "HH:mm").format('hh:mm A')
      let dropofftime = dayjs(this.payload.dropofftime, "HH:mm").format('hh:mm A')


      let pickupLocation = this.locations.filter((item) => {return item.id === this.payload.pickuplocationid})
      let dropoffLocation = this.locations.filter((item) => {return item.id === this.payload.dropofflocationid})

      let payload = {
        location: pickupLocation[0].title,
        dropoff: dropoffLocation[0].title,
        pickupdate: pickupdate,
        dropoffdate: dropoffdate,
        pickuptime: pickuptime,
        dropofftime: dropofftime
      }

      axios.post('/manual-booking/gisborne', payload)
        .then((res) => {
          location.href = '/manual-booking/gisborne'
        })
        .catch((error) => {

        })
    },

    getTime(time) {
      let parsed = dayjs(this.setDateTime(time))
      if (time === '24:00') {
        parsed = dayjs(this.setDateTime('23:59'))
      }

      return parsed.format('HH:mm')
    },

    selectedLocation (id) {
      this.payload.pickuplocationid = id
      let selected = this.locations.filter((item) => {return item.id === id})
      let pickupday = dayjs(this.payload.pickupdate).day()
      if (pickupday === 0) {
        pickupday = 7
      }

      if (selected) {
        this.standDownDay = selected[0].noticerequired_numberofdays
        let schedules = selected[0].officeschedule.filter((item) => {return item.dayofweek === pickupday})
        this.pickupStartTime = this.getTime(schedules[0].startpickup)
        this.pickupEndTime = this.getTime(schedules[0].endpickup)
      }
      this.selected = selected[0]

      if (!this.payload.return) {
        this.payload.dropofflocationid = this.payload.pickuplocationid
      }
    },

    selectedLocationDropoff (id) {

      this.payload.dropofflocationid = id
      this.payload.return = true

      this.setDropoffSchedule(id)
    },

    setDropoffSchedule (id) {

      let selected = this.locations.filter((item) => {return item.id === id})
      let dropoffday = dayjs(this.payload.dropoffdate).day()
      if (dropoffday === 0) {
        dropoffday = 7
      }
      if (selected) {
        let schedules = selected[0]?.officeschedule?.filter((item) => {return item.dayofweek === dropoffday}) || [{}]
        this.dropoffStartTime = this.getTime(schedules[0].startdropoff)
        this.dropoffEndTime = this.getTime(schedules[0].enddropoff)
      }
    },

    toggleForm () {
      this.isOpen = !this.isOpen
    },

    closePopup () {
      this.$root.isBookingHidden = !this.$root.isBookingHidden
    },

    isMobileWidth () {

      this.isOpen = true
      if (document.body.scrollWidth >= 1279) {
        this.isOpen = true
      } else {
        this.isOpen = false
      }
    },

    changeUntilsDisabledDates (date) {

      let current = new Date(date)
      let followingDay = new Date(current.getTime() + 86400000)
      this.payload.dropoffdate = followingDay
      this.disabledDatesUntil.to = current
    },

    isInThePast (date) {
      const today = new Date()
      return date < today
    },

    updatePayload () {
      let current = new Date(this.$store.state.booking.pickupdate)

      const today = new Date()
      let followingDay = new Date(today)
      let followingDayAgain = new Date(today.getTime() + 86400000)

      if (this.isInThePast(current)) {

        this.payload.pickupdate = followingDay
        this.payload.pickuptime = '09:00'
        this.payload.dropoffdate = followingDayAgain
        this.payload.dropofftime = '09:00'
      } else {
        const booking = this.$store.state.booking
        // pickup details
        this.payload.pickuplocationid = booking.pickuplocationid
        this.payload.pickupdate = booking.pickupdate
        this.payload.pickuptime = booking.pickuptime
        // dropoff details
        this.payload.dropofflocationid = booking.dropofflocationid
        this.payload.dropoffdate = booking.dropoffdate
        this.payload.dropofftime = booking.dropofftime

        this.payload.return = booking.return

        // let current = new Date(this.payload.pickupdate)
        this.disabledDatesUntil.to = followingDay
        //other details
        this.payload.vehiclecategorytypeid = booking.vehiclecategorytypeid
        this.payload.ageid = booking.ageid
        this.payload.campaigncode = booking.campaigncode
      }
    },

    setDateTime (timeString) {
      let time = timeString + ':00'

      let now = new Date();
      let nowDateTime = now.toISOString();
      let nowDate = nowDateTime.split('T')[0];
      return dayjs(nowDate + 'T' + time)

    },

  },

  watch: {
    'payload.dropoffdate': function(newValue, oldValue) {
      this.setDropoffSchedule(this.payload.dropofflocationid)
    }
  }
}
</script>
